import { useScreenVariant } from "../../branding/useScreenVariant";
import { ScreenVariant } from "../../branding/selectScreen";
import { BrandScope } from "../../branding/BrandScope";

import ChangePasswordDefault from "./ChangePasswordDefault";
import ChangePasswordBranded from "./ChangePasswordBranded";

function ChangePassword() {
  const { variant, brand } = useScreenVariant();

  switch (variant) {
    case ScreenVariant.BRANDED:
      return (
        <BrandScope brand={brand}>
          <ChangePasswordBranded />
        </BrandScope>
      );
    // Fluxo único: demais variantes (Default/NotPortal/Trading) caem na tela padrão.
    default:
      return <ChangePasswordDefault />;
  }
}

export default ChangePassword;
